module.exports = __webpack_public_path__ + "img/Dropsmith-Aslı-Yazıcıoglu.31abc138.png";